import { CalendarIcon } from "@heroicons/react/24/outline"
import React from "react"
import { twMerge } from "tailwind-merge"

type GroupEventCardMetaLineProps = {
  duration?: string
  locationInfo?: string
  dateLabel?: string
  className?: string
  style?: React.CSSProperties
}

const GroupEventCardMetaLine = ({
  duration,
  locationInfo,
  dateLabel,
  className,
  style
}: GroupEventCardMetaLineProps) => {
  const textParts = [duration, locationInfo].filter(Boolean)
  const textLine = textParts.join(" • ")

  if (!textLine && !dateLabel) return null

  return (
    <div className={twMerge("flex flex-wrap items-center gap-x-1", className)} style={style}>
      {textLine && <span>{textLine}</span>}
      {dateLabel && (
        <>
          {textLine && (
            <span className="px-0.5" aria-hidden="true">
              •
            </span>
          )}
          <span className="inline-flex items-center gap-1">
            <CalendarIcon className="size-4 shrink-0" aria-hidden="true" />
            <span>{dateLabel}</span>
          </span>
        </>
      )}
    </div>
  )
}

export default GroupEventCardMetaLine
